// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__G5m7J","redhead":"Header_redhead__2FVxu"};